import createUseStyles from '@eduzz/houston-styles/createUseStyles';

export const useStyles = createUseStyles((theme) => ({
  root: {
    margin: '32px 0',
  },
  resendBlock: {
    marginTop: 16,
  },
  resendAction: {
    cursor: 'pointer',
    color: theme.feedbackColor.informative.dark,
  },
}));
